import React, { useState } from 'react';

function TransferModal({ departments, users, currentDeptId, onlineUserIds = [], onConfirm, onCancel }) {
  const [deptId, setDeptId] = useState(currentDeptId || '');
  const [agentId, setAgentId] = useState('');
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm({ deptId, agentId, reason });
  };

  // Filtra atendentes pelo departamento selecionado.
  // - Sem departamento: mostra todos
  // - Com departamento: apenas vinculados (admin/supervisor sempre aparecem)
  const filteredUsers = users.filter(u => {
    if (!u.active) return false;
    if (!deptId) return true;
    if (['admin', 'supervisor'].includes(u.role)) return true;
    return Array.isArray(u.department_ids) && u.department_ids.includes(Number(deptId));
  });

  const onDeptChange = (e) => {
    setDeptId(e.target.value);
    setAgentId(''); // reseta atendente ao trocar de departamento
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h3>Transferir atendimento</h3>
        <div className="modal-body">
          <div className="modal-field">
            <label>Departamento</label>
            <select value={deptId} onChange={onDeptChange}>
              <option value="">Sem departamento</option>
              {departments.map(d => (
                <option key={d.id} value={d.id}>{d.name}</option>
              ))}
            </select>
          </div>
          <div className="modal-field">
            <label>Atendente (opcional — deixe em branco para fila do departamento)</label>
            <select value={agentId} onChange={e => setAgentId(e.target.value)}>
              <option value="">Fila do departamento</option>
              {filteredUsers.map(u => {
                const isOnline = onlineUserIds.includes(String(u.id));
                return (
                  <option key={u.id} value={u.id}>{isOnline ? '● ' : '○ '}{u.name}</option>
                );
              })}
            </select>
          </div>
          <div className="modal-field">
            <label>Motivo (opcional)</label>
            <input
              type="text"
              placeholder="Ex: Assunto financeiro"
              value={reason}
              onChange={e => setReason(e.target.value)}
            />
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn-secondary" onClick={onCancel}>Cancelar</button>
          <button className="btn-primary" onClick={handleConfirm}>Transferir</button>
        </div>
      </div>
    </div>
  );
}

export default TransferModal;
